import React, { useState } from 'react';
import './faq.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight, faSearch, faQuestionCircle, faBookOpen, faCreditCard, faHeadset } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const toggle = (key) => {
    setOpenIndex(prev => {
      // Dacă item-ul este deja deschis, îl închidem
      if (prev[key]) {
        return { [key]: false };
      }
      // Altfel, închidem toate și deschidem doar pe acesta
      return { [key]: true };
    });
  };


const faqData = [
  {
    category: "platform",
    categoryName: "Despre ContaLearn",
    icon: faQuestionCircle,
    items: [
      {
        key: "1-1",
        q: "Ce este ContaLearn?",
        a: "ContaLearn este o platforma educationala online prin care poti invata contabilitate folosind lectii interactive, explicatii, exemple practice si exercitii."
      },
      {
        key: "1-2",
        q: "Am nevoie de cunostinte de contabilitate pentru a incepe?",
        a: "Nu. Cursul Bazele contabilitatii este conceput pentru a te familiariza treptat cu notiunile fundamentale, chiar daca nu ai studiat contabilitatea anterior."
      },
      {
        key: "1-3",
        q: "Cui i se adreseaza ContaLearn?",
        a: "Platforma se adreseaza studentilor, antreprenorilor, persoanelor care isi doresc o cariera in contabilitate si celor interesati sa isi dezvolte cunostintele financiare."
      },
      {
        key: "1-4",
        q: "Pot utiliza ContaLearn de pe telefon?",
        a: "Da. Platforma poate fi accesata de pe telefon, tableta si calculator, prin intermediul browserului."
      }
    ]
  },

  {
    category: "courses",
    categoryName: "Cursuri si lectii",
    icon: faBookOpen,
    items: [
      {
        key: "2-1",
        q: "Cum functioneaza lectiile interactive?",
        a: "Lectiile combina explicatiile teoretice cu exercitii interactive care te ajuta sa aplici notiunile prezentate si sa intelegi mecanismele contabile."
      },
      {
        key: "2-2",
        q: "Pot invata contabilitate de la zero?",
        a: "Da. Poti incepe cu Bazele contabilitatii, unde sunt prezentate conceptele fundamentale necesare pentru intelegerea contabilitatii."
      },
      {
        key: "2-3",
        q: "Trebuie sa parcurg lectiile in ordine?",
        a: "Lectiile sunt organizate progresiv. Parcurgerea lor in ordine te ajuta sa intelegi notiunile noi pe baza celor deja invatate."
      },
      {
        key: "2-4",
        q: "Pot reveni asupra unei lectii finalizate?",
        a: "Da. Poti reveni asupra lectiilor deja parcurse pentru a recapitula informatiile si pentru a exersa suplimentar, cat timp ai acces la curs."
      },
      {
        key: "2-5",
        q: "Care este diferenta dintre lectii si aplicatii?",
        a: "Lectiile explica notiunile contabile si verifica intelegerea lor prin exercitii. Aplicatiile te ajuta sa folosesti cunostintele dobandite in situatii practice."
      }
    ]
  },

  {
    category: "premium",
    categoryName: "Preturi si Premium",
    icon: faCreditCard,
    items: [
      {
        key: "3-1",
        q: "Cum pot achizitiona cursul Bazele contabilitatii?",
        a: "Cursul Bazele contabilitatii poate fi achizitionat separat. Consulta pagina de preturi pentru a vedea oferta si pentru a finaliza achizitia."
      },
      {
        key: "3-2",
        q: "Ce cursuri sunt disponibile prin Premium?",
        a: "Celelalte cursuri din oferta ContaLearn sunt accesibile prin contul Premium. Consulta pagina de abonamente pentru a vedea cursurile incluse si disponibilitatea acestora."
      },
      {
        key: "3-3",
        q: "Care este diferenta dintre achizitionarea unui curs si Premium?",
        a: "Achizitionarea individuala iti ofera acces la cursul Bazele contabilitatii, conform ofertei prezentate. Premium este destinat utilizatorilor care doresc sa acceseze si celelalte cursuri incluse in abonament."
      },
      {
        key: "3-4",
        q: "Este obligatoriu sa achizitionez Premium?",
        a: "Nu. Daca doresti sa studiezi doar Bazele contabilitatii, poti alege achizitionarea separata. Pentru accesul la celelalte cursuri este necesar Premium."
      },
      {
        key: "3-5",
        q: "Unde pot verifica pretul abonamentului?",
        a: "Pretul si optiunile de abonare sunt prezentate in pagina de preturi. Verifica oferta afisata inainte de a efectua plata."
      }
    ]
  },

  {
    category: "progress",
    categoryName: "Progres si certificare",
    icon: faBookOpen,
    items: [
      {
        key: "4-1",
        q: "Cum imi pot urmari progresul?",
        a: "ContaLearn iti permite sa urmaresti progresul educational, astfel incat sa identifici lectiile finalizate si etapele pe care trebuie sa le parcurgi."
      },
      {
        key: "4-2",
        q: "Ce se intampla daca nu inteleg o lectie?",
        a: "Poti reveni asupra explicatiilor si poti relua exercitiile pentru a intelege mai bine notiunile prezentate."
      },
      {
        key: "4-3",
        q: "Ce reprezinta punctele XP?",
        a: "XP reprezinta punctele de experienta acumulate prin activitatile educationale. Acestea te ajuta sa iti urmaresti evolutia in platforma."
      },
      {
        key: "4-4",
        q: "Pot obtine o diploma dupa finalizarea cursului?",
        a: "ContaLearn ofera posibilitatea obtinerii unor diplome digitale pentru cursurile eligibile. Consulta informatiile fiecarui curs pentru conditiile de obtinere."
      }
    ]
  },

  {
    category: "account",
    categoryName: "Cont si securitate",
    icon: faQuestionCircle,
    items: [
      {
        key: "5-1",
        q: "Cum imi creez un cont ContaLearn?",
        a: "Acceseaza pagina de inregistrare si completeaza informatiile solicitate. Dupa crearea contului, te poti autentifica si poti explora platforma."
      },
      {
        key: "5-2",
        q: "Ce fac daca mi-am uitat parola?",
        a: "Foloseste optiunea de recuperare a parolei din pagina de autentificare si urmeaza instructiunile pentru resetarea acesteia."
      },
      {
        key: "5-3",
        q: "Pot modifica informatiile contului meu?",
        a: "Da. Acceseaza sectiunea Setari pentru a modifica informatiile de profil care permit editarea."
      },
      {
        key: "5-4",
        q: "Cum sunt protejate datele mele personale?",
        a: "Poti consulta Politica de confidentialitate pentru a afla ce date colecteaza ContaLearn, in ce scop sunt utilizate si ce drepturi ai in legatura cu acestea."
      }
    ]
  },

  {
    category: "support",
    categoryName: "Asistenta si suport",
    icon: faHeadset,
    items: [
      {
        key: "6-1",
        q: "Ce fac daca am efectuat plata, dar nu am acces la curs?",
        a: "Verifica daca esti autentificat in contul folosit la achizitie. Daca problema persista, contacteaza echipa de suport si ofera informatiile necesare pentru verificarea tranzactiei. Nu transmite datele complete ale cardului."
      },
      {
        key: "6-2",
        q: "Cum pot raporta o problema tehnica?",
        a: "Poti trimite un mesaj prin formularul de feedback sau poti contacta echipa la contact@contalearn.ro. Descrie problema si, daca este posibil, ataseaza o captura de ecran."
      },
      {
        key: "6-3",
        q: "Pot raporta o greseala intr-o lectie?",
        a: "Da. Foloseste optiunile de feedback disponibile in platforma si mentioneaza cursul, lectia si informatia pe care doresti sa o semnalezi."
      }
    ]
  }
];



const normalizeText = (text) =>
  String(text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const normalizedSearch = normalizeText(searchTerm);

const filteredData = faqData
  .filter(
    (cat) =>
      activeCategory === "all" ||
      cat.category === activeCategory
  )
  .map((cat) => ({
    ...cat,
    items: cat.items.filter((item) =>
      normalizeText(`${item.q} ${item.a}`).includes(
        normalizedSearch
      )
    ),
  }))
  .filter((cat) => cat.items.length > 0);


  return (
    <div className="faq-container">
 

      <div className='ajutor-title-top-faq'>


           <div className='tittle-ab-top'>
            <h4>Intrebari frecvente</h4>
        </div>
       

      
      </div>

      <div className='faq-search-section'>
        <div className='search-box'>
          <FontAwesomeIcon icon={faSearch} className='search-icon' />
          <input
            type='text'
            placeholder='Cauta in intrebari...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='search-input'
          />
        </div>
        
        <div className='category-filters'>
          <button 
            className={`filter-btn ${activeCategory === 'all' ? 'active' : ''}`}
            onClick={() => setActiveCategory('all')}
          >
            Toate
          </button>
          {faqData.map(cat => (
            <button 
              key={cat.category}
              className={`filter-btn ${activeCategory === cat.category ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat.category)}
            >
              <FontAwesomeIcon icon={cat.icon} />
              {cat.categoryName}
            </button>
          ))}
        </div>
      </div>

      {filteredData.length === 0 ? (
        <div className='no-results'>
          <FontAwesomeIcon icon={faQuestionCircle} className='no-results-icon' />
          <h3>Nu am gasit rezultate</h3>
          <p>Incearca sa reformulezi cautarea sau contacteaza-ne direct</p>
        </div>
      ) : (
        filteredData.map((category) => (
          <div className="faq-category" key={category.category}>
            <div className='title-help'>
              <FontAwesomeIcon icon={category.icon} className='category-icon' />
              <h3>{category.categoryName}</h3>
              
            </div>
            <div className='line-ajutor'></div>

            {category.items.map((item, index) => (
              <React.Fragment key={item.key}>
                <div className={`faq-item ${openIndex[item.key] ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => toggle(item.key)}>
                    <span>{item.q}</span>
                    <FontAwesomeIcon icon={faChevronDown} className="icon" />
                  </div>
                  <div className="faq-answer">
                    <p>{item.a}</p>
                  </div>
                </div>
                {index < category.items.length - 1 && <div className='line-ajutor'></div>}
              </React.Fragment>
            ))}
          </div>
        ))
      )}

      
      <section className='section-cta-aj'>
        <div className='cta-content-faq'>
          <h3>Nu ai gasit raspunsul?</h3>
          <p>Echipa noastra este aici sa te ajute</p>
          <div className='cta-buttons-faq'>
            <Link
  to="/feedback"
>
  Trimite feedback
</Link>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
